import { get, post } from './requests';
import qs from 'query-string'

export function getPrices(couponId, role) {
  const url = qs.stringifyUrl({
    url: '/purchase/v1/prices',
    query: { coupon_id: couponId, role },
  }, { skipNull: true });
  return get(url).then(res => res.json());
}

export function getBecomeAHeroPrices() {
  return get('/purchase/v1/become_a_hero/prices').then(res => res.json());
}

export function makeBecomeAHeroPurchase(values) {
  return post('/purchase/v1/become_a_hero/buy', values).then(res => res.json());
}

export function makePurchase(values) {
  return post('/purchase/v1/buy', values).then(res => res.json());
}

export function getCoupon(code) {

  const url = qs.stringifyUrl({
    url: `/purchase/v1/coupon`,
    query: { code }
  }, { skipNull: true });

  return get(url).then(res => res.json());
}